// extracted by mini-css-extract-plugin
export default {"p_tye":"c841a90936","slcted":"caaeea1932","slc_color":"_45c50ab2a2","item_p":"_8309f0cd15","r0":"_430f3c99fe"};